import request from '@/utils/request'
import {
  getServerIpConfigApiUrl,
  getCheckServerAccessPermissionApiUrl,
  getEditAccessApplyRecordApiUrl,
  getTunnelAddress
} from '@/utils/apiUrl'

const SERVER_LIST_CACHE_KEY = 'serverIpConfigList'
const SERVER_ACCESS_VERIFIED_PREFIX = 'serverAccessVerified_'
let serverListPromise = null

export function isSilkmilesHost() {
  return window.location.href.includes('silkmiles.com')
}

export { getTunnelAddress }

function normalizeTunnelUrl(url) {
  return (url || '').trim().replace(/\/+$/, '').toLowerCase()
}

function getVerifiedCacheKey(tunnelAddress) {
  return SERVER_ACCESS_VERIFIED_PREFIX + normalizeTunnelUrl(tunnelAddress)
}

export function isServerAccessVerified(tunnelAddress) {
  return sessionStorage.getItem(getVerifiedCacheKey(tunnelAddress)) === '1'
}

export function setServerAccessVerified(tunnelAddress) {
  sessionStorage.setItem(getVerifiedCacheKey(tunnelAddress), '1')
}

export function matchTunnelAddress(configTunnel, currentTunnel) {
  return normalizeTunnelUrl(configTunnel) === normalizeTunnelUrl(currentTunnel)
}

export async function fetchServerIpConfigList() {
  const cached = sessionStorage.getItem(SERVER_LIST_CACHE_KEY)
  if (cached) {
    try {
      return JSON.parse(cached)
    } catch (e) {
      sessionStorage.removeItem(SERVER_LIST_CACHE_KEY)
    }
  }
  if (serverListPromise) {
    return serverListPromise
  }
  serverListPromise = request({
    url: getServerIpConfigApiUrl(),
    method: 'POST',
    params: {
      page: 1,
      limit: 100
    },
    silent: true
  }).then((res) => {
    const list = res.data || []
    sessionStorage.setItem(SERVER_LIST_CACHE_KEY, JSON.stringify(list))
    return list
  }).finally(() => {
    serverListPromise = null
  })
  return serverListPromise
}

export async function resolveServerAccess() {
  if (isSilkmilesHost()) {
    return { allowed: true }
  }
  const tunnelAddress = getTunnelAddress()
  if (isServerAccessVerified(tunnelAddress)) {
    return { allowed: true }
  }
  try {
    const list = await fetchServerIpConfigList()
    const matched = list.find((item) => matchTunnelAddress(item.tunnelAddress, tunnelAddress))
    if (!matched) {
      return { allowed: true }
    }
    if (matched.serverType === 1 || String(matched.serverType) === '1') {
      return { allowed: true }
    }
    return { needAuth: true, tunnelAddress }
  } catch (e) {
    console.error('[serverAccess]', e)
    return { allowed: true }
  }
}

export function checkServerAccessPermission(params) {
  return request({
    url: getCheckServerAccessPermissionApiUrl(),
    method: 'POST',
    params
  })
}

export function editAccessApplyRecord(params) {
  return request({
    url: getEditAccessApplyRecordApiUrl(),
    method: 'POST',
    params
  })
}



// WEBPACK FOOTER //
// ./src/utils/serverAccess.js